import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RegisterPermitOnBallparkAPI } from "api/ballpark";
import { RegisterParkingOnBallparkAPI } from "api/ballpark";
import { RegisterOnBallparkAPI } from "api/ballpark";
import { GetBallparkLocationsAPI } from "api/ballpark";

const handleThunkError = (err, { rejectWithValue }) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  locations: [],
  loading: false,
};

export const getBallparkLocations = createAsyncThunk(
  "ballpark/getLocations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetBallparkLocationsAPI(data);
      return response.data;
    } catch (err) {
      console.log("get loc error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const registerOnBallpark = createAsyncThunk(
  "ballpark/registerOnBallpark",
  async (subscriptionId, { rejectWithValue }) => {
    try {
      const response = await RegisterOnBallparkAPI({ subscriptionId });
      return response.data;
    } catch (err) {
      console.log("Error while registering on ballparc ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const registerParkingOnBallpark = createAsyncThunk(
  "ballpark/registerParkingOnBallpark",
  async (reservationId, { rejectWithValue }) => {
    try {
      const response = await RegisterParkingOnBallparkAPI({ reservationId });
      return response.data;
    } catch (err) {
      console.log("Error while registering on ballparc ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const registerPermitOnBallpark = createAsyncThunk(
  "ballpark/registerPermitOnBallpark",
  async (permitId, { rejectWithValue }) => {
    try {
      const response = await RegisterPermitOnBallparkAPI({ permitId });
      return response.data;
    } catch (err) {
      console.log("Error while registering on ballparc ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const ballparkSlice = createSlice({
  name: "ballpark",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getBallparkLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBallparkLocations.fulfilled, (state, { payload }) => {
        state.locations = payload.data;
        state.loading = false;
      })
      .addCase(getBallparkLocations.rejected, (state) => {
        state.loading = false;
      }),
});

export default ballparkSlice.reducer;
